export default __webpack_public_path__ + "static/media/vip.5684c750.svg";